import { ConversationInsightsFiltersV1Schema } from "@redotech/redo-model/conversation-filters/conversation-insights-filters";
import { ConversationInsightsSchema } from "@redotech/redo-model/conversation-insights";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const ConversationInsightsItem_ = z.object({
  _id: zExt.objectId(),
  createdAt: z.date(),
  closedAt: z.date().optional(),
  lastResponseAt: z.date().optional(),
  platform: z.string(),
  conversationInsights: ConversationInsightsSchema.optional(),
});

export const ConversationInsightsItem: z.ZodType<ConversationInsightsItem> =
  ConversationInsightsItem_;
export interface ConversationInsightsItem
  extends z.infer<typeof ConversationInsightsItem_> {}

export const getConversationInsights = {
  name: "getConversationInsights" as const,
  input: z.object({
    pageNumber: z.number().optional(),
    pageSize: z.number().int().positive(),
    filters: ConversationInsightsFiltersV1Schema.optional(),
  }),
  output: z.object({ data: z.array(ConversationInsightsItem) }),
};
